export const CARD_BRANDS = {
  amex: "American Express",
  diners: "Diners Club",
  discover: "Discover",
  jcb: "JCB",
  mastercard: "Mastercard",
  unionpay: "UnionPay",
  visa: "Visa",
  unknown: "Card",
} as const;

export function getCardBrandDisplayName(
  brand: string | undefined | null,
): string {
  if (!brand) return "Card";
  return brand in CARD_BRANDS
    ? CARD_BRANDS[brand as keyof typeof CARD_BRANDS]
    : "Card";
}
